/**
 * Outcome log for the analysis poll, the one recorder boundary TypeScript owns.
 * Uses the same `module: rpa` and `op` shape as the Rust upload row; see the
 * Telemetry section of `UPLOAD-README.md`. The backend's `error_message` never
 * logs, and `error_code` logs only as a SCREAMING_SNAKE token.
 */
import { pluginCoreLogger } from '@heidi/plugin-core';

export type RecordingAnalysisOutcome = 'ready' | 'failed' | 'timeout';

const MACHINE_TOKEN = /^[A-Z0-9_]+$/;

/** PHI belt: only SCREAMING_SNAKE tokens are loggable. */
export const machineToken = (value: string | undefined): string | undefined =>
  value !== undefined && MACHINE_TOKEN.test(value) ? value : undefined;

export interface RecordingAnalysisTelemetry {
  readonly outcome: RecordingAnalysisOutcome;
  readonly sessionId: string;
  readonly recordingId: string;
  readonly durationMs: number;
  /** Poll requests issued, including ones that threw. */
  readonly polls: number;
  readonly errorCode?: string;
}

export function logRecordingAnalysisOutcome(telemetry: RecordingAnalysisTelemetry): void {
  const errorCode = machineToken(telemetry.errorCode);
  pluginCoreLogger().info({
    msg: '[rpa-recorder] recording_analysis',
    module: 'rpa',
    op: 'recording_analysis',
    outcome: telemetry.outcome,
    native_session_id: telemetry.sessionId,
    recording_id: telemetry.recordingId,
    duration_ms: telemetry.durationMs,
    polls: telemetry.polls,
    ...(errorCode === undefined ? {} : { error_code: errorCode }),
  });
}
